<template>
  <section class="mt-5">
    <h2>登録申込</h2>
    <div class="form-navi my-5">
      <ul class="d-flex flex-wrap">
        <li class="px-3">申込登録</li>
        <li class="px-3">内容確認</li>
        <li class="px-3">商品注文</li>
        <li class="px-3">カート確認</li>
        <li class="px-3">お届け/お支払</li>
        <li class="here px-3">最終確認</li>
        <li class="px-3">申込完了</li>
      </ul>
    </div>
    <h3 class="form-ttl">最終確認</h3>
    <p class="exp">
      以下の内容でよろしければ入会申込みを確定するを押してください。
    </p>

    <div class="form-order-confirm border box-p-20 my-5">
      <div class="d-flex py-3 border-bottom only_pc">
        <div class="shohin_group text-center">
          <p>商品</p>
        </div>
        <div class="shohin_quantity text-center">
          <p>個数</p>
        </div>
        <div class="shohin_price text-center">
          <p>価格</p>
        </div>
      </div>
      <div id="CartList" data-v-19516808="">
        <ul data-v-19516808="">
          <li
            class="d-flex align-items-center border-bottom"
            data-v-19516808=""
          >
            <div
              class="shohin_group d-flex align-items-center my-3"
              data-v-19516808=""
            >
              <p data-v-19516808="">1</p>
              <img
                src="/web/contents/products/101/thumb.jpg"
                alt="薬用スキンウォッシュ"
                class="mx-4"
                data-v-19516808=""
              />
              <p data-v-19516808="">薬用スキンウォッシュ</p>
            </div>
            <div class="shohin_quantity text-center my-3" data-v-19516808="">
              1個
            </div>
            <div class="shohin_price my-3" data-v-19516808="">
              <p class="text-right" data-v-19516808="">5,250円</p>
            </div>
          </li>
          <li
            class="d-flex align-items-center border-bottom"
            data-v-19516808=""
          >
            <div
              class="shohin_group d-flex align-items-center my-3"
              data-v-19516808=""
            >
              <p data-v-19516808="">2</p>
              <img
                src="/web/contents/products/150/thumb.jpg"
                alt="フローラ ファーストセラム"
                class="mx-4"
                data-v-19516808=""
              />
              <p data-v-19516808="">フローラ ファーストセラム</p>
            </div>
            <div class="shohin_quantity text-center my-3" data-v-19516808="">
              1個
            </div>
            <div class="shohin_price my-3" data-v-19516808="">
              <p class="text-right" data-v-19516808="">7,350円</p>
            </div>
          </li>
        </ul>
      </div>
      <!-- 動的HTML生成部 カート小計 -->
      <div id="CartSubtotal" class="d-flex my-3">
        <div class="shohin_price_all text-right">
          <p>小計</p>
        </div>
        <div class="shohin_price text-right">
          <p>12,600円</p>
        </div>
      </div>
      <div class="style-d-flex my-3">
        <div class="shohin_price_all text-right">
          <p>代金引換手数料</p>
        </div>
        <div class="shohin_price text-right">
          <p>0円</p>
        </div>
      </div>
      <div class="d-flex my-3">
        <div class="shohin_price_all text-right">
          <p>送料</p>
        </div>
        <div class="shohin_price text-right">
          <p>0円</p>
        </div>
      </div>
      <div class="d-flex my-3">
        <div class="shohin_price_all text-right">
          <p>合計</p>
        </div>
        <div class="shohin_price text-right">
          <p>12,600円</p>
        </div>
      </div>
      <div class="box-p-20 text-center mt-5">
        <router-link
          :to="{ path: '/mock/influencer/order/confirm' }"
          class="btn d-inline-block"
        >
          カートに戻る
        </router-link>
      </div>
    </div>
    <div class="form-member border box-p-20 mb-5">
      <h3 class="mb-5 teext-left">お届け先、お届け日、お支払方法</h3>
      <div id="divDeliveryConfirm" class="inner">
        <dl style="margin-bottom: 0; border-bottom: 0">
          <dt>お受取りについて</dt>
          <dd>本人が受取ることを同意する</dd>
          <dt>お届け先</dt>
          <dd>ご自宅</dd>
        </dl>
        <dl>
          <dt>お届け指定日</dt>
          <dd>2022/00/00</dd>
          <dt>お届け時間帯</dt>
          <dd>指定なし</dd>
          <dt>お支払方法</dt>
          <dd>クレジットカード</dd>
        </dl>
      </div>
      <div class="box-p-20 text-center mt-5">
        <router-link
          :to="{ path: '/mock/influencer/delivery' }"
          class="btn d-inline-block"
        >
          お届け、お支払方法を変更する
        </router-link>
      </div>
    </div>
    <div class="form-member border box-p-20 mb-5">
      <div class="inner">
        <h3 class="mb-5 teext-left">申込者情報</h3>
        <dl id="divRegistrationConfirm">
          <!-- 動的生成部 -->
          <form>
            <dl id="dlConfirm">
              <dt>氏名</dt>
              <dd>真奈&emsp;美須子</dd>
              <dt>氏名<span class="fs-08">（フリガナ）</span></dt>
              <dd>マナ&emsp;ビスコ</dd>
              <dt>性別</dt>
              <dd>女性</dd>
              <dt>配偶者</dt>
              <dd>無し</dd>
              <dt>生年月日</dt>
              <dd>0000/00/00</dd>
              <dt>郵便番号</dt>
              <dd>2790032</dd>
              <dt>住所</dt>
              <dd>千葉県浦安市千鳥15-9</dd>
              <dt>住所<span class="fs-08">（フリガナ）</span></dt>
              <dd>チバケンウラヤスシチドリ15バンチ8</dd>
              <dt>住所<span class="fs-08">（建物名）</span></dt>
              <dd>マナビスマンション101</dd>
              <dt>住所<span class="fs-08">（その他）</span></dt>
              <dd>浦安舞子方</dd>
              <dt>配送時連絡先</dt>
              <dd>携帯電話番号</dd>
              <dt>
                携帯電話番号
              </dt>
              <dd>0888888888</dd>
              <dt>
                自宅電話番号
              </dt>
              <dd></dd>
              <dt>FAX番号</dt>
              <dd></dd>
              <dt>パスワード</dt>
              <dd>password0000</dd>
              <dt>当社からの広告等のメール・SMS・FAX送信</dt>
              <dd>承諾しない</dd>
              <dt>重要事項への同意</dt>
              <dd>同意する</dd>
            </dl>
          </form>
        </dl>
      </div>
      <div class="box-p-20 text-center mt-5">
        <router-link :to="{ path: '/mock/influencer/registration' }" class="btn d-inline-block">
          申込者情報の登録へ戻る
        </router-link>
      </div>
    </div>
    <div class="d-flex justify-content-center mb-5">
      <router-link
        :to="{ path: '/mock/influencer/delivery/end' }"
        class="btn d-inline-block mt-5"
      >
        クレジットカード情報入力
      </router-link>
    </div>
  </section>
  <div>
    <p class="text-center">株式会社マナビス化粧品</p>
    <p class="text-center">
      ◆お問い合わせ mc-info@manavis-cosme.co.jp
    </p>
  </div>
</template>

<style scoped>
.cart_set dl {
  display: flex;
  flex-wrap: wrap;
  border-right: 1px solid #eee;
  border-bottom: 1px solid #eee;
}
.cart_set dt {
  width: 300px;
  padding: 10px 15px;
  border-top: 1px solid #eee;
  border-left: 1px solid #eee;
  background: #fafafa;
}
.cart_set dd {
  padding: 10px 15px;
  width: calc(100% - 300px);
  border-top: 1px solid #eee;
  border-left: 1px solid #eee;
}
@media screen and (min-width: 1px) and (max-width: 699px) {
  .cart_set dt,
  .cart_set dd {
    width: 100%;
  }
}
</style>


<script>

export default {
  mounted() {
    window.scroll(0, 0);
  }
};

</script>
